import { person } from "../lib/data";

const Footer = () => {
  return (
    <footer className="border-t border-[color:var(--nn-border)] py-10 md:py-14 mt-0" data-testid="footer">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
        <div className="font-mono text-[11px] uppercase tracking-widest text-[color:var(--nn-muted)]">
          © 2026 Nirav Nayak · Handcrafted in Toronto
        </div>
        <div className="text-center font-serif italic text-lg">
          "Details are not details, they make the design."
        </div>
        <div className="md:text-right font-mono text-[11px] uppercase tracking-widest text-[color:var(--nn-muted)]">
          <a href={`mailto:${person.email}`} data-cursor="hover" className="link-underline">
            {person.email}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
